import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Link4ExceptionService {

    isValid(): boolean {
        return false;
    }
}

